import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';

import { WeatherStation } from 'types';

export const getWeatherStations = async (): Promise<
  WeatherStation[] | undefined
> => {
  const { data }: { data: WeatherStation[] } = await axios.get(
    `/api/weather/stations`
  );
  return data as WeatherStation[];
};

type QueryFnType = typeof getWeatherStations;

type UseWeatherStationsOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useWeatherStations = ({ config }: UseWeatherStationsOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['weatherStations'],
    queryFn: () => getWeatherStations(),
    ...config,
  });
};
